import styled from 'styled-components';
import { StyledLoaderProps } from './Loader.types';

export const StyledLoader = styled.div<StyledLoaderProps>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) => props.customStyle}
`;
